import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminCoordinationRequestsQueryKeys = {
  index: (params?: Record<string, any>) => ['adminCoordinationRequests', params] as const,
};

// Coordination requests are served by the generic admin reviews index, keyed by type.
const URL = 'admin/reviews';
const REVIEW_TYPE = 'coordinate_request';

export type CoordinationRequestStatus = 'pending' | 'auto_completed' | 'completed' | 'auto_dismissed' | 'dismissed';

export type CoordinationRequestSource = 'integration' | 'user';

export type AdminCoordinationRequest = {
  id: string;
  patientName: string;
  status: CoordinationRequestStatus;
  source: CoordinationRequestSource;
  submittedBy: string;
  providerType: { id: string; displayName: string } | null;
  user: string;
  createdAt: string;
  updatedAt: string;
  client: { id: string; name: string };
};

export type AdminCoordinationRequestIndexParams = BaseIndexQueryParams & {
  status?: string | string[];
  client?: string | string[];
  source?: string | string[];
  provider_type?: string | string[];
  created_at?: string;
};

export async function adminIndexCoordinationRequests(
  params: AdminCoordinationRequestIndexParams,
  signal?: GenericAbortSignal
): Promise<Paginated<AdminCoordinationRequest>> {
  return http
    .get<Paginated<AdminCoordinationRequest>>(URL, { params: { ...params, type: REVIEW_TYPE }, signal })
    .then((res) => res.data);
}
